require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ru-pages-freight-forwarder.json") })
        }
      }, "path---ru-pages-freight-forwarder");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ru-pages-freight-forwarder!./.cache/json/ru-pages-freight-forwarder.json
// module id = 787
// module chunks = 231608221292675